export default "__VITE_ASSET__9fcf1bee__"